import { normalizeURL } from "./normalizeUrl"

export const makeUrl = (url: string) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url
  }

  return normalizeURL(url)
}
